import styled from "styled-components";

export const CardContainer = styled.div`
  background: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 90px;
  height: 262px;
  padding: 12px 14px;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
    pointer-events: none;
  }
`;

export const CardButton = styled.div`
  background: none;
  border: none;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  font-size: 18px;
  padding: 12px 18px;
  border-radius: 9999px;
  align-self: center;
  width: fit-content;
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ hasLinkText }) =>
    hasLinkText ? "space-between" : "end"};
  z-index: 10;
  height: 34px;
`;

export const CardLink = styled.span`
  color: rgba(255, 255, 255, 0.6);
`;

export const CardArrow = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  padding: 7px;
  border-radius: 9999px;
  line-height: 0;
`;
